import { render } from "./HelpSupport.vue?vue&type=template&id=5398a731&scoped=true"
import script from "./HelpSupport.vue?vue&type=script&lang=js"
export * from "./HelpSupport.vue?vue&type=script&lang=js"

import "./HelpSupport.vue?vue&type=style&index=0&id=5398a731&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5398a731"]])

export default __exports__